import React from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import logo from "../../../assets/website/images/logo.png";

const SwayydFooter = () => {
  const globalDetails = useSelector((state) => state.globalDetails?.data);

  return (
    <footer className="swayyd-footer">
      <div className="footer-inner">
        <div className="footer-brand">
          <div className="footer-logo" style={{ color: "white" }}>
           <img className="w-10 h-10  border-black border-white rounded-[9px]" src={logo} alt="logo" />
          </div>
          <p className="footer-desc">
            Your wardrobe intelligence app. Know what you own,
            wear it with intention, and let go of the rest.
          </p>
        </div>
        <div className="footer-links">
          <div className="footer-col-title">Product</div>
          <div className="footer-col-links">
            <a href="/#features">Features</a>
            <a href="/#bae">Bae! AI</a>
            <a href="/#faq">FAQ</a>
            <a href="/#contact">Contact</a>
          </div>
        </div>
        <div className="footer-links">
          <div className="footer-col-title">Legal</div>
          <div className="footer-col-links">
            <Link to="/privacy-policy">Privacy</Link>
            <Link to="/terms">Terms</Link>
          </div>
        </div>
        <div className="footer-links">
          <div className="footer-col-title">Contact</div>
          <div className="footer-col-links">
            <a href={`mailto:${globalDetails?.admin_email || "hello@veysh.com"}`}>{globalDetails?.admin_email || "hello@veysh.com"}</a>
            <Link to="/contact-us">Support</Link>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <div className="footer-legal">
          &copy; {new Date().getFullYear()} {globalDetails?.title || "Veysh"}. {globalDetails?.copy_right_text || "All rights reserved."}
        </div>
        <div className="footer-right">
          Made with ❤️ for your wardrobe
        </div>
      </div>
    </footer>
  );
};

export default SwayydFooter;
